(function () {
    
        "use strict";
    
        angular.module("smartbrokr")
    
            .controller("SignupCompleteController", function ($state) {
                var self = this;
            });
    })();